import { PlantNetBrand } from './PlantNetBrand.js'

window.customElements.define('plantnet-brand', PlantNetBrand)
